import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import FlightInfo from "features/layout/components/journey-view/components/flight-info/FlightInfo";
import PassengerInfo from "features/layout/components/journey-view/components/passenger-info/PassengerInfo";
import usePaxSession from "features/shared/hooks/usePaxSession";
import Body from "features/shared/styles/typography/Body.styled";
import { useState } from "react";
import { useAppStore } from "store/store";

import useShouldBeVisible from "./hooks/useShouldBeVisible";
import DesktopFlightInfo from "./styles/DesktopFlightInfo.styled";
import JourneyContainer from "./styles/JourneyContainer.styled";
import MobileFlightInfo from "./styles/MobileFlightInfo.styled";
import ShowFlightInfoButton from "./styles/ShowFlightInfoButton.styled";
import JourneyWrapper from "./styles/JourneyWrapper.styled";

const JourneySection = () => {
  useAppStore((state) => state.locale);
  const textUI = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });
  const direction = Content.shared.instance.dir();

  const journey = useAppStore((state) => state.journey);
  const isPaxVisible = useShouldBeVisible();
  const paxSession = usePaxSession();
  const [isFlightShown, showFlight] = useState(true);

  if (!journey) {
    return null;
  }

  return (
    <JourneyContainer
      aria-label="journey section"
      data-testid="journey-section"
      isPaxVisible={isPaxVisible}
    >
      <JourneyWrapper isPassengerInfoShown={isPaxVisible}>
        {paxSession && isPaxVisible ? (
          <PassengerInfo
            data-testid="passenger-info"
            passenger={paxSession.pax}
            status={paxSession.checklist.resolutionStatus}
            requiredAction={paxSession.requiredAction}
          />
        ) : null}
        <MobileFlightInfo isFlightShown={isFlightShown}>
          {paxSession && isPaxVisible ? (
            <ShowFlightInfoButton
              direction={direction}
              data-testid="show-flight-toggle"
              icon={LocalImages.shared.images.icons.chevron.down}
              isFlightShown={isFlightShown}
              onClick={() => showFlight(!isFlightShown)}
            >
              <Body>
                {isFlightShown
                  ? textUI("hide-flight-details")
                  : textUI("show-flight-details")}
              </Body>
            </ShowFlightInfoButton>
          ) : null}
          {isFlightShown ? <FlightInfo flight={journey} /> : null}
        </MobileFlightInfo>
        <DesktopFlightInfo>
          <FlightInfo flight={journey} />
        </DesktopFlightInfo>
      </JourneyWrapper>
    </JourneyContainer>
  );
};

export default JourneySection;
